var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProductUpdate(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9822_6309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2 3.09004C16.94 2.95004 16.62 2.97004 16.37 3.14004L15.55 3.67004C14.3 4.51004 12.94 5.15004 11.53 5.58004C10.11 6.01004 8.63 6.23004 7.12 6.23004H5.5C4.57 6.23004 3.69 6.59004 3.03 7.25004C2.37 7.92004 2 8.79004 2 9.73004C2 10.67 2.37 11.55 3.03 12.21C3.69 12.86 4.57 13.23 5.5 13.23H6.23C6.2 13.44 6.15 13.64 6.1 13.83C5.96 14.33 5.77 14.76 5.56 15.01C5.3 15.34 5.35 15.81 5.67 16.07C5.99 16.33 6.46 16.28 6.72 15.96C7.13 15.45 7.37 14.85 7.54 14.23C7.63 13.91 7.7 13.58 7.76 13.26H8C10.7 13.41 13.29 14.28 15.54 15.78L16.36 16.32C16.5 16.42 16.65 16.46 16.81 16.46C16.94 16.46 17.07 16.43 17.2 16.36C17.47 16.22 17.63 15.96 17.63 15.65V3.80004C17.63 3.50004 17.46 3.23004 17.2 3.09004ZM5.5 11.61C5 11.61 4.52 11.42 4.17 11.06C3.81 10.71 3.62 10.24 3.62 9.73004C3.62 9.22004 3.81 8.75004 4.17 8.39004C4.53 8.03004 5 7.84004 5.5 7.84004H6.31V11.61H5.5ZM16.01 14.16C13.56 12.64 10.79 11.78 7.93 11.64V7.82004C10.79 7.68004 13.56 6.82004 16.01 5.30004V14.16Z",
    fill: "#5E5E66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9822_6309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.63,
    height: 13.46,
    fill: "white",
    transform: "translate(2 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductUpdate);
export default __webpack_public_path__ + "static/media/product-update.36f51f2f.svg";
export { ForwardRef as ReactComponent };